import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/images/trophy.svg'
import _imports_1 from '@/images/notebook.svg'
import _imports_2 from '@/images/award.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-6 h-6",
    alt: "trophy"
  })
], -1)
const _hoisted_2 = { class: "bg-permaBlack5 md:w-440px w-full rounded-xl sm:p-6 p-4" }
const _hoisted_3 = { class: "flex items-center justify-between sm:pb-4 pb-2 border-b border-permaWhite5" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode()
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://medium.com/@Permaswap/limitless-stress-test-6f2bd738aa74",
  target: "_blank",
  rel: "noopener noreferrer"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "w-5 h-5 ml-1",
    alt: "教程"
  })
], -1)
const _hoisted_7 = { class: "sm:mt-4 mt-2" }
const _hoisted_8 = { class: "text-14px text-white" }
const _hoisted_9 = { class: "text-12px text-permaWhite2" }
const _hoisted_10 = { class: "sm:p-4 p-3 bg-permaGreen13 rounded-xl sm:mt-4 mt-3" }
const _hoisted_11 = { class: "text-permaGreen4" }
const _hoisted_12 = { class: "sm:p-4 p-3 bg-permaGreen13 rounded-xl sm:mt-4 mt-3" }
const _hoisted_13 = { class: "sm:p-4 p-3 bg-permaGreen13 rounded-xl sm:mt-4 mt-3 text-14px" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center border-b border-permaWhite5 pb-2" }, [
  /*#__PURE__*/_createTextVNode(" Top5 "),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "w-4 h-4",
    alt: "award"
  })
], -1)
const _hoisted_15 = { class: "flex justify-between text-permaWhite2 items-center sm:my-4 my-2" }
const _hoisted_16 = {
  key: 0,
  class: "flex items-center justify-center text-permaWhite2",
  style: {"min-height":"100px"}
}
const _hoisted_17 = { key: 1 }

import { ref, watchEffect, onMounted, onUnmounted, computed } from 'vue'
import { getStressTestInfo, getStressTestUserStats } from '@/libs/api'
import { StressTestInfo, StressTestUserStats } from '@/libs/types'
import { handleErrorMsg, formatMoney } from '@/libs/util'
import { validValues, formatAmountThreeDigits } from '@/pages/swap/index'
import SimpleWrapper from '../SimpleWrapper.vue'
import TradingLabel from './TradingLabel.vue'
import NavbarSection from '../Navbar/NavbarSection.vue'
import MoreInfo from '../common/MoreInfo.vue'
import { useStore } from '@/store'
import { useI18n } from 'vue-i18n'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
interface Props {
visible: boolean
}
interface Emits {
  (e:'showModal'):void
  (e: 'close'):void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    visible: null
  },
  emits: ["showModal", "close"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e:'showModal'):void
  (e: 'close'):void
}), expose: any, slots: any, attrs: any }) {

dayjs.extend(duration)


const { t } = useI18n()
const store = useStore()
const endInTime = ref('')
const endInDate = ref('')
const stressTestInfo = ref<StressTestInfo>({} as StressTestInfo)
const stressTestUserStats = ref<StressTestUserStats>({} as StressTestUserStats)
const account = computed(() => store.state.account)
const updateStressTestTime = (stratTime:number, endTime: number) => {
  const startDate = dayjs(stratTime * 1000).format('YYYY.MM.DD')
  const endDate = dayjs(endTime * 1000).format('YYYY.MM.DD')
  const diffTime = dayjs.duration((endTime * 1000) - (dayjs().unix() * 1000))
  endInTime.value = dayjs().unix() > endTime ? 'Closed' : `${diffTime.days()}d ${diffTime.hours()}h ${diffTime.minutes()}m ${diffTime.seconds()}s`
  endInDate.value = `${startDate} ~ ${endDate}`
}
let stressTestTimer = null as any
const intervalUpdateTestTime = () => {
  stressTestTimer && clearTimeout(stressTestTimer)
  stressTestTimer = setTimeout(() => {
    if (stressTestInfo.value.startAt && stressTestInfo.value.endAt) {
      updateStressTestTime(stressTestInfo.value.startAt, stressTestInfo.value.endAt)
    }
    intervalUpdateTestTime()
  }, 1000)
}
const shortAddress = (address:string) => {
  return address.slice(0, 4) + '...' + address.slice(-2)
}

watchEffect(async () => {
  try {
    if (account.value) {
      stressTestUserStats.value = await getStressTestUserStats(account.value)
    } else {
      stressTestUserStats.value = {} as StressTestUserStats
    }
  } catch (e:any) {
    handleErrorMsg(e, t)
  }
})
onMounted(async () => {
  try {
    stressTestInfo.value = await getStressTestInfo()
  } catch {
  }
  intervalUpdateTestTime()
})
onUnmounted(() => {
  stressTestTimer && clearTimeout(stressTestTimer)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NavbarSection, {
      class: _normalizeClass(["bg-permaGreen1 p-2 w-10 transition-colors mr-2", __props.visible ? 'text-white border-permaGreen9' : 'hover:border-permaGreen11 border-permaGreen2 border-opacity-25 text-permaWhite1 hover:text-white']),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('showModal')))
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(SimpleWrapper, { class: "md:w-440px" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(MoreInfo, {
                info: _unref(t)('trading.title'),
                "is-left": true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('trading.tips.title')), 1)
                ]),
                _: 1
              }, 8, ["info"]),
              _hoisted_5,
              _hoisted_6
            ]),
            _createElementVNode("i", {
              class: "el-icon-close cursor-pointer text-xl opacity-65",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('close')))
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(endInDate.value), 1),
            _createElementVNode("div", _hoisted_9, " End In: " + _toDisplayString(endInTime.value), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(TradingLabel, {
              label: _unref(t)('trading.total_rewards'),
              "label-tips": [_unref(t)('trading.tips.total_rewards')],
              class: "sm:pb-2 pb-0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, _toDisplayString(stressTestInfo.value.userRewardAmount) + " AR", 1)
              ]),
              _: 1
            }, 8, ["label", "label-tips"]),
            _createVNode(TradingLabel, {
              label: _unref(t)('trading.total_volume'),
              "label-tips": [_unref(t)('trading.tips.total_volume')],
              class: "pt-2.5"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(stressTestInfo.value.totalUserVolume ? stressTestInfo.value.totalUserVolume < 1 ? `$${_unref(formatAmountThreeDigits)(_unref(validValues)(stressTestInfo.value.totalUserVolume, 2))}` : `$${_unref(formatMoney)(stressTestInfo.value.totalUserVolume, 0)}` : '-'), 1)
              ]),
              _: 1
            }, 8, ["label", "label-tips"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(TradingLabel, {
              label: _unref(t)('trading.my_volume'),
              "label-tips": [_unref(t)('trading.tips.my_volume')],
              class: "sm:pb-2 pb-0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(!_unref(account) ? '-' : stressTestUserStats.value.volume ? (stressTestUserStats.value.volume < 1 ? '< $1' : `$${_unref(formatMoney)(stressTestUserStats.value.volume, 0)}`) : '-'), 1)
              ]),
              _: 1
            }, 8, ["label", "label-tips"]),
            _createVNode(TradingLabel, {
              label: _unref(t)('trading.my_volume_chare'),
              "label-tips": [_unref(t)('trading.tips.my_volume_chare'), _unref(t)('trading.tips.my_volume_chare2')],
              class: "pt-2.5 sm:pb-2 pb-0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(!_unref(account) ? '-' : stressTestUserStats.value.percent * 100 ? ((stressTestUserStats.value.percent * 100) < 0.01 ? '< 0.01%' : `${_unref(formatMoney)(stressTestUserStats.value.percent * 100, 2)}%`) : '-'), 1)
              ]),
              _: 1
            }, 8, ["label", "label-tips"]),
            _createVNode(TradingLabel, {
              label: _unref(t)('trading.my_est_rewards'),
              "label-tips": [_unref(t)('trading.tips.my_est_rewards')],
              class: "pt-2.5"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(!_unref(account) ? '-' : stressTestUserStats.value.reward ? (stressTestUserStats.value.reward < 0.01 ? '< 0.01 AR' : `${_unref(formatMoney)(stressTestUserStats.value.reward, 2)} AR` ) : '-'), 1)
              ]),
              _: 1
            }, 8, ["label", "label-tips"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", null, _toDisplayString(_unref(t)('trading.address')), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(t)('trading.est_rewards')), 1)
            ]),
            (!stressTestInfo.value?.userTop5?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(t)('no_data')), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stressTestInfo.value.userTop5, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass(["flex justify-between items-center", index !== 0 ? 'mt-2 sm:mt-4' : ''])
                    }, [
                      _createElementVNode("div", null, _toDisplayString(shortAddress(item.accid)), 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(formatAmountThreeDigits)(_unref(validValues)(item.reward, 2))) + " AR", 1)
                    ], 2))
                  }), 128))
                ]))
          ])
        ], 512), [
          [_vShow, __props.visible]
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})